import { css } from "@emotion/react"
import { ON_TERTIARY_CONTAEINER_COLOR } from "style"
import { MouseEventHandler, ChangeEventHandler, useState, FocusEventHandler, ReactNode } from "react"
import { IconContext} from "react-icons"

const height = '10rem'
const fontSize = '1rem'

const textFieldStyle = css`
  display: flex;
`

const iconAreaStyle = css`
  width: 3rem;
  height: ${height};
  font-size: 1.5rem;
  line-height: ${height};
  text-align: center;
  color: #555;
`

const textareaAreaContainerStyle = css`
  position: relative;
  width: 100%;
`

const textareaAreaStyle = css`
  flex:1;
  display: grid;
  place-items: center;
`

const messageStyle = css`
  overflow: hidden;
  overflow-wrap: break-word;
  height: ${height};
  width: 100%;
  font-size: ${fontSize};
  box-sizing: border-box;
  padding: 2rem 1rem 1rem 1rem;
  resize: none;
  color: #666;
  background-color: #fff;
  border-width: 1px;
  border-radius: 0.3rem;
  margin-bottom: 1rem;
  
  &:focus{
    outline-color: ${ON_TERTIARY_CONTAEINER_COLOR};
  }
`

const labelStyle = css`
  position: absolute;
  color: #555;
  left: 1rem;
  top: 20%;
  transform: translateY(-50%);
  font-size: ${fontSize};
  transition: all 0.2s;
`

const smallCharStyle = css`
  top: 1rem;
  font-size: 1.3rem;
  color: ${ON_TERTIARY_CONTAEINER_COLOR};
`

type Props = {
  icon: ReactNode,
  placeholder: string,
  value?: string,
  readonly?: boolean,
  onChange: ChangeEventHandler<HTMLTextAreaElement>,
}

export const TextField = (props: Props)=>{

  const [isFocus, setIsFocus] = useState<boolean>(false)
  const [isFilled, setIsFilled] = useState<boolean>(!isLengthZeto(props.value))

  const labelCss = (isFilled || isFocus)? [labelStyle, smallCharStyle] : labelStyle
  
  const onClick: MouseEventHandler = (evt) =>{
    evt.stopPropagation()
  }

  const onFocus: FocusEventHandler<HTMLTextAreaElement> = (evt) =>{
    evt.stopPropagation()
    setIsFocus(true)
  }

  const onBlur: FocusEventHandler<HTMLTextAreaElement> = (evt) =>{
    evt.stopPropagation()
    setIsFocus(false)
  }

  const onChange: ChangeEventHandler<HTMLTextAreaElement> = (evt) =>{
    if(evt.target.value.length === 0){
      setIsFilled(()=>false)
    }else{
      setIsFilled(()=>true)
    }

    if(props.onChange){
      props.onChange(evt)
    }
  }

  return(
    <div css={textFieldStyle} onClick={onClick}>
      <div css={iconAreaStyle}>
        <IconContext.Provider value={{size: "1.5rem"}}>
          {props.icon}
        </IconContext.Provider>
      </div>
      <div css={textareaAreaStyle}>
        <div css={textareaAreaContainerStyle}>
          <textarea 
            css={messageStyle}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={onChange}
            value={props.value}
          />
          <label css={labelCss}>{props.placeholder}</label>
        </div>
      </div>
    </div>
  )
}

const isLengthZeto = (str? : string) : boolean =>{
  return [undefined, null, ""].includes(str)
}